export default __webpack_public_path__ + "static/media/907.b408bd50.png";